/*
 * @Description: 搜索条件字段 fields静态数据 searchFilter字段过滤方法
 * @Date: 2020-01-03 13:24:00
 */

//静态数据
const fields = [
  {
    tip: '会议地址', // 显示label与过滤时条件标识
    key: 'visitAddress', // 搜索条件对应字段
    slot: 'input' // 交互类型
  },
  {
    tip: '任务月度',
    key: 'taskDt',
    width: 120, // 宽度
    slot: 'date'
  },
  {
    tip: '任务编码',
    key: 'taskCode',
    width: 120, // 宽度
    slot: 'input'
  },
  {
    tip: '医院',
    key: 'hospitalName',
    slot: 'input'
  },
  {
    tip: '手机号',
    key: 'phone',
    slot: 'input'
  },
  {
    tip: '药店',
    key: 'hospitalName',
    slot: 'input'
  },
  {
    tip: '机构',
    key: 'hospitalName',
    slot: 'input'
  },
  {
    tip: '医疗机构',
    key: 'hospitalName',
    slot: 'input'
  },
  {
    tip: '医院等级',
    key: 'gradeName',
    slot: 'input'
  },
  {
    tip: '时间区间',
    text: '导出',
    key: ['startDt', 'endDt'], // 对应值
    //未提交审核 4审核中 5审核未通过 6审核通过
    slot: 'daterange',
    width: 380
  },
  {
    tip: '项目参与人',
    key: 'fullName',
    width: 130,
    required: false,
    slot: 'input'
  },
  {
    tip: '经营者',
    key: 'fullName',
    width: 130,
    required: false,
    slot: 'input'
  },
  // 0 未提交审核 1审核中 2审核通过 3审核未通过
  {
    tip: '审核状态',
    key: 'authStatus',
    // 选项数据
    options: [
      {
        name: '全部',
        key: ''
      },
      {
        name: '审核中',
        key: 1
      },
      {
        name: '审核通过',
        key: 2
      },
      {
        name: '审核不通过',
        key: 3
      },
      {
        name: '任务失效',
        key: 4
      }
    ],
    slot: 'select'
  },
  {
    tip: '结算状态',
    id: '',
    use: [1],
    key: 'signing_status',
    // 选项数据
    options: [
      {
        name: '全部',
        key: ''
      },
      {
        name: '可结算',
        key: 2
      },
      {
        name: '不可结算',
        key: -1
      }
    ],
    slot: 'select'
  },
  //todo 协定服务
  {
    tip: '签约状态',
    key: 'signStatus',
    width: 160,
    // 选项数据
    options: [
      {
        name: '全部',
        key: ''
      },
      {
        name: '未签约',
        key: 1
      },
      {
        name: '已签约',
        key: 2
      },
      {
        name: '签约失败',
        key: 3
      }
    ],
    slot: 'select'
  },
  {
    tip: '任务完成率',
    key: 'orderType',
    options: [
      {
        name: '升序排列',
        key: 'asc'
      },
      {
        name: '降序排列',
        key: 'desc'
      }
    ],
    slot: 'select'
  },
  {
    tip: '任务完成率 ',
    key: 'order',
    options: [
      {
        name: '升序排列',
        key: 1
      },
      {
        name: '降序排列',
        key: 2
      }
    ],
    slot: 'select'
  },
  {
    tip: '药店名称',
    key: 'customerName',
    slot: 'input'
  },
  {
    tip: '患者姓名',
    slot: 'input',
    key: 'patientName'
  },
  {
    tip: '运营编码',
    key: 'operateProjectNo',
    id: 'operateProjectNo',
    slot: 'input'
  },
  {
    tip: '个体',
    slot: 'input',
    key: 'zooidEnterpriseName'
  }
];

// 通过tip筛选需要的条件
const searchFilter = (needFields = []) => {
  let list = [];
  for (let i of needFields) {
    if (Object.prototype.toString.call(i) === '[object Object]') {
      list.push(i);
    }
    for (let j of fields) {
      if (i === j.tip) {
        list.push(j);
      }
    }
  }
  return list;
};

export default searchFilter;
export { fields };
